import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { shopifyIntegrationQuery } from "modules/settings/lib/shopify/shopifyIntegrationQuery"

export function useDeleteShopifyIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      await axios.delete("/integrations/shopify")
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: shopifyIntegrationQuery().queryKey })
    },
  })
}
